import { generateHash, Metadata, parseFFMpegMetadataFromLogs, probeToMetadata } from "../utils/video";

async function analyzeFile(file: File, callback: any) {
    try {
        //console.log("analizing file", file)
        let filepath = await window.electron.getFilePath(file);
        //console.log("filepath", filepath)

        /*const result = await window.electron.runFFprobeCommand([
            '-analyzeduration', '5000000',  // 5 секунд
            '-probesize', '10000000',       // 10 МБ
            '-i', filepath
        ]);*/
        const result = await window.electron.runFFprobeCommand([
            '-v','error',
            '-show_format', '-show_streams',       
            '-print_format','json',
            filepath
          ]);
        //console.log("result", result);          

        if (result?.result?.stdout) {
            console.log("result", result.result.stdout);
            let metadata = probeToMetadata(result.result.stdout);
            metadata.name = file.name,
            metadata.type = file.type,
            metadata.lastModified = new Date(file.lastModified).toISOString();

            metadata.size = file.size;
            metadata.path = filepath;
            const uniqueString = `${metadata.size}_${metadata.width}_${metadata.height}_${metadata.fps}_${metadata.duration}_${metadata.format}_${metadata.videoCodec}_${metadata.audioCodec}_${metadata.bitrate}_${metadata.sampleRate}_${metadata.creationDate}_${metadata.lastModified}`;
            metadata.hash = await generateHash(uniqueString);
            callback({ type: 'metadata', metadata });
        } else if (result?.result?.stderr) { //I don't know why result is in stderr
            let metadata: Metadata = parseFFMpegMetadataFromLogs(result.result.stderr);
            metadata.name = file.name,
            metadata.type = file.type,
            metadata.lastModified = new Date(file.lastModified).toISOString();

            metadata.size = file.size;
            metadata.path = filepath;
            const uniqueString = `${metadata.size}_${metadata.width}_${metadata.height}_${metadata.fps}_${metadata.duration}_${metadata.format}_${metadata.videoCodec}_${metadata.audioCodec}_${metadata.bitrate}_${metadata.sampleRate}_${metadata.creationDate}_${metadata.lastModified}`;
            metadata.hash = await generateHash(uniqueString);
            callback({ type: 'metadata', metadata });
        } else {
            callback({ type: 'error', error: result?.error || 'Analize file error' });
        }
    } catch (err: any) {
        console.error("Error analyzing file", err);
        callback({ type: 'error', error: err.error || 'Failed to analyze file' });
    }
}

async function convert(file: File, metadata: Metadata, callback:(params:any)=>void, id: string) {
    let dirToSave = await getDirToSave();
    if (!dirToSave) {
        callback({ type: 'error', error: 'No directory choosed to save the converted file' });
        return;
    }
    try {
        let filepath = metadata?.path || await window.electron.getFilePath(file);
        let newfilepath = dirToSave + "/" + file.name.replace(/\.[^/.]+$/, "") + "_" + id + ".mp4" //to make file unique;

        const onProcessEventHandler = (_: any, message: any) => {
            const timeMatch = message?.data?.match(/time=([\d:.]+)/);

            if (timeMatch && metadata?.duration) {
                const timeString = timeMatch[1]; //string "00:01:30.90"
                const [hours, minutes, seconds] = timeString.split(':').map(parseFloat);
                const totalSeconds = hours * 3600 + minutes * 60 + seconds;
                const progress = Math.floor(totalSeconds / (metadata.duration) * 100)
                callback({ type: "progress", progress, time: timeString });
            }

        };

        window.electron.on("converting", onProcessEventHandler);

        const result = await window.electron.runFFmpegCommand([
            '-y', //resave
            '-i', filepath,
            '-vf', 'scale=960:-1',
            '-c:v', 'libx264',
            '-crf', '23',
            '-preset', 'medium',
            '-c:a', 'aac',
            '-b:a', '128k',
            newfilepath
        ]);
        window.electron.off("converting", onProcessEventHandler);
        console.log("result", result);
        if (result.success) {
            let _file = await window.electron.getFIleShim(newfilepath);
            callback({ type: 'convertedFile', file: _file });
        } else {
            callback({ type: 'error', error: result?.error || 'Convert file error' });
        }
    } catch (err: any) {
        console.error("Error converting file", err);
        callback({ type: 'error', error: err.error || 'Failed to analyze file' });
    }
}

async function stopConvert(callback:(params:any)=>void) {
    try {
        let result = await window.electron.stopFFmpegCommand();
        console.log("result", result);
        if (result.success) {
            callback({ type: 'stopped' });
        } else {
            callback({ type: 'error', error: result?.error || 'Stop converting file error' });
        }
    } catch (err: any) {
        console.error("Error stop converting file", err);
        callback({ type: 'error', error: err.error || 'Failed to analyze file' });
    }
}

async function detachAudio(file: File, metadata :Metadata, callback: any) {
    let dirToSave = await getDirToSave();
    if (!dirToSave) {
        callback({ type: 'error', error: 'No directory choosed to save the audio file' });
        return;
    }
    console.log("input file",file,metadata);
    let audiofilepath = dirToSave + "/" + file.name.replace(/\.[^/.]+$/, ".mp3");

    let path=metadata.transcoded ? file.path : (metadata.path || await window.electron.getFilePath(file));
    if (!path) {
        callback({ type: 'error', error: "Can't get file path" });
        return;
    }
    try {
        const result = await window.electron.runFFmpegCommand([
            '-y', //resave
            '-i', path,
            '-q:a', '0',
            '-map', 'a',
            audiofilepath
        ]);
        console.log("result", result);
        if (result.success) {
            let _file = await window.electron.getFIleShim(audiofilepath,"audio/mp3");
            callback({ type: 'audioFile', file: _file });
        } else {
            callback({ type: 'error', error: result?.error || 'Detach audio error' });;
        }
    } catch (err: any) {
        console.error("Error analyzing file", err);
        callback({ type: 'error', error: err.error || 'Failed to analyze file' });
    }
}

const getDirToSave=async ()=>{
    let dirToSave = localStorage.getItem("save_dir");
    if (!dirToSave) {
        dirToSave = await window.electron.runSelectDirectoryCommand();
        if (dirToSave) {
            localStorage.setItem("save_dir", dirToSave);
        }
    }
    return dirToSave
}

export const runElectronCommand = async (props: any) => {
    const { action, id, callback, metadata, ...rest } = props;

    switch (action) {
        case 'analyze':
            analyzeFile(rest.file, callback);
            break;
        case 'convert':
            convert(rest.file, metadata, callback, id);
            break;
        case 'stopConvert':
            stopConvert(callback);
            break;
        case 'detachAudio':
            detachAudio(rest.file, metadata, callback);
            break;
        default:
            callback({ type: 'error', id, error: 'Unknown action: ' + action });
    }
}